import React, { Component } from "react";

class  Painel extends Component {
  render() {
    return (
      <div className="panel panel-default">
        {this.props.title ? (
          <div className="panel-heading font-bold">{this.props.title}</div>
        ) : null}
        <div className="panel-body">{this.props.children}</div>
      </div>
    );
  }
}

export default Painel;



// WEBPACK FOOTER //
// ./src/components/Painel/index.js